mutation RestoreLanguages($ids: [ID!]!) {
  restoreLanguages(ids: $ids) {
    id
    deletedAt
  }
}
